import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface NoteFormState {
  isOpen: boolean
  leadId: number | null
  userId: number | null
  initialNote: string | null
  noteId: number | null
  isEdit: boolean
}

const initialState: NoteFormState = {
  isOpen: false,
  leadId: null,
  userId: null,
  initialNote: null,
  noteId: null,
  isEdit: false
}

const noteFormSlice = createSlice({
  name: 'noteForm',
  initialState,
  reducers: {
    showNoteForm: (
      state,
      action: PayloadAction<{
        leadId: number
        userId: number
        initialNote?: string
        noteId?: number
        isEdit?: boolean
      }>
    ) => {
      state.isOpen = true
      state.leadId = action.payload.leadId
      state.userId = action.payload.userId
      state.initialNote = action.payload.initialNote || null
      state.noteId = action.payload.noteId || null
      state.isEdit = action.payload.isEdit || false
    },
    hideNoteForm: (state) => {
      state.isOpen = false
      state.leadId = null
      state.userId = null
      state.initialNote = null
      state.noteId = null
      state.isEdit = false
    }
  }
})

export const { showNoteForm, hideNoteForm } = noteFormSlice.actions
export default noteFormSlice.reducer
